/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Pin_On_SaveInputs */

const en_views_pin_on_save = /** @type {(inputs: Views_Pin_On_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pin to the sidebar`)
};

const de_views_pin_on_save = /** @type {(inputs: Views_Pin_On_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An die Seitenleiste heften`)
};

/**
* | output |
* | --- |
* | "Pin to the sidebar" |
*
* @param {Views_Pin_On_SaveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_pin_on_save = /** @type {((inputs?: Views_Pin_On_SaveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Pin_On_SaveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_pin_on_save(inputs)
	return en_views_pin_on_save(inputs)
});